import React from "react";
import { gql } from "@apollo/client";

import { Typography } from "@mui/material";
import { Close as SoundShapeRemoveIcon } from "mdi-material-ui";

const Icon = () => <SoundShapeRemoveIcon />;

const Title = () => <span>Sound shaping supprimé</span>;

const Content = ({ orderEvent }) => (
  <Typography variant="h4" color="primary" component="div">
    {orderEvent.soundShaping.mouthpieceRef.name}
  </Typography>
);

const fragments = {
  orderEvent: gql`
    fragment Orders_OrderEvent_SoundShapeRemoveEvent_OrderEvent on OrderEvent {
      id

      ... on OrderEvent_SoundShapeRemove {
        soundShaping {
          id
          mouthpieceRef {
            id
            name
          }
        }
      }
    }
  `,
};

const Event = { Icon, Title, Content, fragments };

export default Event;
